import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getColor() {
  const data = await axiosInstance({
    url: "/color",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createColor = async (formData: any) => {
  const data = await axiosInstance({
    url: "/color",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateColor = async (formData: any) => {
  const data = await axiosInstance({
    url: `/color/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteColor = async (formData: any) => {
  const data = await axiosInstance({
    url: `/color/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useColor() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.color],
    queryFn: () => getColor(),
  });
  return data;
}

export function useCreateColor() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createColor(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.color]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateColor() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateColor(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.color]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteColor() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteColor(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.color]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
